/* eslint-disable no-unreachable */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable multiline-ternary */
import React, { useContext, useRef, useState } from 'react';
import { DialogContent, Dialog, Grid, DialogTitle, Typography, Box, IconButton, DialogActions, Button, Tabs, Tab, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RiDeleteBinLine } from 'react-icons/ri';
import { BiArrowBack } from 'react-icons/bi';
import { LanguageContext } from '../../../../../../../libs/Context';
import { useSelector } from 'react-redux';
import { s3DeleteNew, s3FileUpload } from '../../../../../../../libs/HelperContent';
import Loading from '../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { toast } from 'react-toastify';
import { getDesignElements, planeCard, DesignElement } from '../../../../Reusable/EventCardUtils';
import { useMediaQuery, useTheme } from '@mui/system';

const EventCardNew = (props) =>
{
	const { open, handleCloseTemp, handleNext, updateOccasionTem, feedType } = props;
	const fileInputRef = useRef<HTMLInputElement>(null);
	const [ selectedImage, setSelectedImage ] = useState<any>({
		index : null,
		url   : ''
	});
	const [ customBg, setCustomBg ] = useState<any>({});
	const [ loading, setLoading ] = useState<boolean>(false);
	const userData = useSelector((state: any) => state?.mysession?.session);
	const { language } = useContext(LanguageContext);
	const path = `${userData?.companyId}/feed`;
	const [ value, setValue ] = useState(0);
	const theme = useTheme();
	const upMD = useMediaQuery(theme.breakpoints.up(700));
	const handleChange = (newValue: number) =>
	{
		setValue(Number(newValue));
	};

	// Plane Cards for mobile specific
	const planeCard1 = [
		{ key: 'eventC1', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/eventC1.png` },
		{ key: 'eventC2', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/eventC2.png` },
		{ key: 'eventC3', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/eventC3.png` },
		{ key: 'eventC4', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/eventC4.png` },
		{ key: 'eventC5', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/eventC5.png` },
		{ key: 'eventC6', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/eventC6.png` }
	];
	// GIF Cards common for web and mobile
	const gifCard = [
		{ key: 'gifC1', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/occasions_gif_1.gif` },
		{ key: 'gifC2', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/occasions_gif_2.gif` },
		{ key: 'gifC3', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/occasions_gif_3.gif` },
		{ key: 'gifC4', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/occasions_gif_4.gif` },
		{ key: 'gifC5', src: `${process.env.REACT_APP_S3_BASE_URL}/public/feed/occassion/occasions_gif_5.gif` }
	];
	const handleFileClick = () =>
	{
		if (fileInputRef.current)
		{
			fileInputRef.current.click();
		}
	};
	const handleFileUpload = async (event) =>
	{
		setLoading(true);
		const file = event.target.files[0];

		if (file)
		{
			const fileType = file?.type;

			if (![ 'image/png', 'image/jpeg', 'image/jpg', 'image/gif' ].includes(fileType))
			{
				toast.error(language.SelectValidImageFile);
				setLoading(false);

				return;
			}

			if (file.size > 1048576)
			{
				toast.error(language.fileSizeShouldNotBeMoreThan1MB);
				setLoading(false);

				return;
			}

			const upload = await s3FileUpload(file, path);

			if (upload)
			{
				setCustomBg(upload);
				setSelectedImage((prev) => ({
					...prev,
					index : null,
					url   : ''
				}));
				setLoading(false);
			}
			else
			{
				setLoading(false);
			}
		}
		else
		{
			setLoading(false);
		}
	};

	const handleDelete = async () =>
	{
		if (Object.keys(customBg)?.length > 0)
		{
			await s3DeleteNew(customBg?.key, '');
		}
		setCustomBg({});
	};
	const handleCardClick = (index, img) =>
	{
		setSelectedImage((prev) => ({
			...prev,
			index,
			url : img
		}));
	};
	const handleAddBg = () =>
	{
		const obj:any = {};

		if (Object.keys(customBg)?.length > 0 && selectedImage?.index === null)
		{
			obj.templateUrlWeb = customBg?.url;
			obj.templateUrlMob = customBg?.url;
			obj.templateId = customBg?.key;
		}
		else
		{
			const matchedCard = planeCard1.find((card) => card.key === selectedImage?.url);

			handleDelete();
			obj.templateUrlMob = matchedCard?.src || selectedImage?.url;
			obj.templateUrlWeb = selectedImage?.url;
			obj.templateId = new Date().valueOf();
		}

		feedType === 'editOccasion' ? updateOccasionTem(obj, 0) : handleNext(obj, 0);
	};

	const btnDisabled = selectedImage?.index === null && Object?.keys(customBg)?.length === 0;

	return (
		<Dialog
			open={open}
			onClose={() => { handleDelete(); handleCloseTemp(1); }}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			{loading && <Loading />}
			<DialogTitle>
				<Grid container display={'flex'} alignItems={'center'} pb='var(--pixel8)'>
					<Grid item display={'flex'} alignItems={'center'} onClick={() => { handleDelete(); handleCloseTemp(1); }} sx={{ cursor: 'pointer' }} pr='var(--pixel8)'>
						<BiArrowBack/>
					</Grid>
					<Grid item xs >
						<Typography fontWeight='var(--font500)' sx={{ cursor: 'pointer' }}>{language?.selectTemp}</Typography>
					</Grid>
					<Grid item display={'flex'} alignItems={'center'} onClick={() => { handleDelete(); handleCloseTemp(0); }} >
						<CloseIcon className='lightTxt pointer'/>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Box
							alignItems='center' justifyContent='center'
							display='flex'
							sx={{ backgroundColor: '#E2F3FF', borderRadius: '13px', cursor: 'pointer', width: 'var(--percent100)', height: 'var(--font140)', aspectRatio: '16 / 9', position: 'relative' }}
							onClick={handleFileClick}
						>
							{Object.keys(customBg)?.length > 0 ? (
								<>
									<Box
										component='img'
										src={customBg?.url}
										alt='Uploaded Template'
										sx={{ width: 'var(--percent100)', borderRadius: 'var(--pixel8)', height: 'var(--percent100)', objectFit: 'contain' }}
									/>
									<Box
										sx={{
											position        : 'absolute',
											top             : 10,
											right           : 10,
											width           : 24,
											height          : 24,
											borderRadius    : 'var(--percent50)',
											backgroundColor : 'rgba(255, 255, 255, 1)',
											display         : 'flex',
											alignItems      : 'center',
											justifyContent  : 'center'
										}}
									>
										<Tooltip title={language?.delete} placement='top'>
											<IconButton onClick={handleDelete}>
												<RiDeleteBinLine fontSize='var(--pixel16)' className='lightTxt' />
											</IconButton>
										</Tooltip>
									</Box>
								</>
							) : (
								<>
									<Typography variant='inherit' fontSize={'var(--pixel16)'} fontWeight='var(--font500)' color={'primary'}>
										{language.uploadWebinarBg}
									</Typography>
									<input
										type='file'
										ref={fileInputRef}
										style={{ display: 'none' }}
										accept='.png, .jpeg, .jpg, .gif'
										onChange={handleFileUpload}
									/>
								</>
							)}

						</Box>
					</Grid>
					<Grid item xs={12}>
						<Tabs
							value={value}
							onChange={(event, newValue) => handleChange(newValue)}
							variant='scrollable'
							scrollButtons='auto'
							aria-label='scrollable auto tabs example'
							allowScrollButtonsMobile
						>
							<Tab label={language.cards} value={0} />
							<Tab label={language?.gif} value={1} />
						</Tabs>

					</Grid>
					<Grid container p='var(--pixel8)'>
						{value === 0 ? (
							planeCard?.map((celeb, index) => (
								<Grid item key={celeb?.key} xs={12} sm={6} lg={6} sx={{ padding: 'var(--pixel8)', position: 'relative' }}>
									<button
										tabIndex={0}
										onClick={() => handleCardClick(index, celeb?.key)}
										onKeyUp={(e) =>
										{
											e.key === 'Enter' && handleCardClick(index, celeb?.key);
										}}
										style={{
											width        : 'var(--percent100)',
											display      : 'inline-flex',
											borderRadius : '13px',
											padding      : '0',
											overflow     : 'hidden',
											border       : selectedImage?.index === index ? '3px solid var(--primaryColor)' : '1px solid var(--boxshadow0-5)'
										}}
									>
										<Box
											alignItems='center'
											display='flex'
											sx={{
												borderRadius : 'var(--pixel8)',
												cursor       : 'pointer',
												width        : 'var(--percent100)',
												position     : 'relative',
												background   : celeb.src,
												height       : '180px'
											}}
										>
											{getDesignElements(celeb?.eventType, feedType, upMD).map((item, idx) => (
												<DesignElement key={idx} item={item} />
											))}
										</Box>
									</button>
								</Grid>
							)))
							: (gifCard?.map((celeb, index) =>
								(
									<Grid item key={celeb?.key} xs={12} sm={6} lg={6} sx={{ padding: 'var(--pixel8)', position: 'relative' }}>
										<button
											tabIndex={0}
											onClick={() => handleCardClick(index, celeb?.src)}
											onKeyUp={(e) =>
											{
												e.key === 'Enter' && handleCardClick(index, celeb?.src);
											}}
											style={{
												width        : 'var(--percent100)',
												display      : 'inline-flex',
												borderRadius : '13px',
												padding      : '0',
												overflow     : 'hidden',
												border       : selectedImage?.index === index ? '3px solid var(--primaryColor)' : '1px solid var(--boxshadow0-5)'
											}}
										>
											<Box component='img' src={celeb.src} alt={`img-${index}`} sx={{ width: 'var(--percent100)', height: 'var(--percent100)', borderRadius: '13px' }} />
										</button>
									</Grid>
								)))
						}
					</Grid>
				</Grid>
			</DialogContent>
			{/* Final submission for next steps */}
			<DialogActions sx={{ padding: '12px 24px 12px 0' }}>
				<Button tabIndex={0} disableElevation disableRipple
					variant='contained' sx={{ color: 'var(--whiteColor)' }}
					disabled={btnDisabled}
					onClick={() => handleAddBg()}
					className={btnDisabled ? 'disableMode buttonBg' : 'buttonBg'}
				>
					{language?.next}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EventCardNew;